<template>
  <div id="home-featured-carousel">
    <div :id="`featured-carousel-${carouselId}`" class="swiper-container">
      <div class="swiper-wrapper">
        <div v-for="(slide, index) in featuredData"
             :key="slide.id"
             class="swiper-slide"
        >
          <div v-if="hasIndex" class="slide-index">
            {{ index + 2 }}
          </div>
          <EpisodeCard :episode="slide"
                       :artist="slide.mainArtist"
                       :artist-name="true"
          />
        </div>
      </div>
    </div>
    <div :id="`home-featured-carousel-prev-${carouselId}`" class="swiper-button-prev unset">
      <ArrowCarouselPrev />
    </div>
    <div :id="`home-featured-carousel-next-${carouselId}`" class="swiper-button-next">
      <ArrowCarouselNext />
    </div>
  </div>
</template>
<script>
import Swiper, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
Swiper.use(Navigation);

import EpisodeCard from '@/components/cards/EpisodeCard.vue';
import ArrowCarouselNext from '@/components/svg/ArrowCarouselNext.vue';
import ArrowCarouselPrev from '@/components/svg/ArrowCarouselPrev.vue';

export default {
  name: 'HomeFeaturedCarousel',
  components: {
    EpisodeCard,
    ArrowCarouselNext,
    ArrowCarouselPrev
  },
  props: {
    featuredData: {
      type: Array,
      required: true
    },
    carouselId: {
      type: String,
      required: true
    },
    hasIndex: {
      type: Boolean,
      required: false,
      default: false
    },
    slidesPerView: {
      type: Number,
      required: false,
      default: 4
    }
  },
  data() {
    return {
      carouselConfig: {
        freeMode: {
          enabled: true,
          sticky: true,
          momentum: false,
          momentumBounce: false
        },
        // speed: 500,
        slidesPerGroup: 1,
        slidesPerView: 1.5, 
        spaceBetween: 10,
        loop: false,
        simulateTouch: true,
        navigation: {
          nextEl: `#home-featured-carousel-next-${this.carouselId}`,
          prevEl: `#home-featured-carousel-prev-${this.carouselId}`
        },
        breakpoints: {
          480: {
            slidesPerView: 2.5,
            spaceBetween: 10
          },
          640: {
            slidesPerView: 3.5,
            spaceBetween: 10,
            slidesPerGroup: 3
          },
          1025: {
            slidesPerView: this.slidesPerView,
            spaceBetween: 10,
            slidesPerGroup: 3
          }
        }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initCarousel();
    });
  },
  methods: {
    initCarousel() {
      new Swiper(`#featured-carousel-${this.carouselId}`, this.carouselConfig);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_home-featured-carousel.scss';
</style>
